import { Form } from '@remix-run/react'
import { cva } from 'class-variance-authority'
import { useState } from 'react'

const linkVariants = cva('cursor-pointer', {
  variants: {
    variant: {
      'purple-400': `
        text-purple-400

        hover:text-purple-200
      `,
      white: `
        text-white

        hover:text-primary
      `,
      black: `
        text-foreground

        hover:font-semibold
      `,
      primary: `
        text-primary-600

        hover:text-primary
      `,
    },
  },
})

type CarLinkProps = {
  carSlug: string
  className?: string
  children: React.ReactNode
  variant?: 'white' | 'black' | 'primary' | 'purple-400'
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export default function CarLink({
  carSlug,
  className = '',
  children,
  variant,
  onClick,
}: CarLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    setIsSubmitting(true)
    onClick?.(e as unknown as React.MouseEvent<HTMLButtonElement>)
  }

  return (
    <Form
      method="post"
      action="/api/carLink"
      className={`
        inline-block w-full text-left

        ${linkVariants({ variant, className })}
      `}
      onSubmit={handleSubmit}
    >
      <input type="hidden" name="carSlug" value={carSlug} />
      <button
        type="submit"
        className={`
          m-0 block w-full cursor-pointer appearance-none border-0
          bg-transparent p-0 text-inherit font-inherit text-left
        `}
        disabled={isSubmitting}
      >
        {children}
      </button>
    </Form>
  )
}
